module.exports = __webpack_public_path__ + "static/media/awards-cup.5b719ecc.svg";